import AppModel from '../app/app-model';
import PersonalinfoModel from '../personalinfo/personalinfo-model';
import ProductModel from '../product/product-model';
import RegionModel from '../region/region-model';

export default class AddressModel {
    id: number;
    name: string;
    description: string;
    status: string;
    type: string;
    typeCaption: string;
    street: string;
    region: any;
    regionCaption: string;
    link: string;
    linkIcon: string;
    linkPath: string;
    seq: number;
    personalinfo: any;
    personalinfoCaption: string;
    app: any;
    appCaption: string;
    product: any;
    productCaption: string;

    constructor(datarow:any) { 
        if (datarow.attributes) datarow = {...datarow.attributes, id: datarow.id}
        this.id = datarow.id;
        this.name = datarow.name;
        this.description = datarow.description;
        this.status = datarow.status || 'active';
        this.type = datarow.type || 'address-general';
        let type = AddressModel.optionType.filter((d: any) => d.name === this.type)?.[0];
        this.typeCaption = type?.caption || 'General';
        this.street = datarow.street;
        let region = datarow.region?.data? new RegionModel(datarow.region?.data) : datarow.region;
        this.region = region?.id;
        this.regionCaption = region?.name;
        this.link = datarow.link;
        this.linkIcon = type?.icon || '';
        this.linkPath = this.link.startsWith('http')? this.link : (type?.path || '' ) + this.link;
        this.seq = datarow.seq;
        let personalinfo = datarow.personalinfo?.data? new PersonalinfoModel(datarow.personalinfo?.data) : datarow.personalinfo;
        this.personalinfo = personalinfo?.id;
        this.personalinfoCaption = personalinfo?.name; 
        let app = datarow.app?.data? new AppModel(datarow.app?.data) : datarow.app;
        this.app = app?.id;
        this.appCaption = app?.name; 
        let product = datarow.product?.data? new ProductModel(datarow.product?.data) : datarow.product;
        this.product = product?.id;
        this.productCaption = product?.name;
        
    } 

    public static endPoint: string = 'addresses';
    public static endPointFilterList = (parentType?: string, parentId?: number) => {
        return ('?populate=*&sort=seq&filters[' + (parentType || 'personalinfo') + ']=' + parentId);
    }
    public static url: string = '/address';
    public static caption: string = 'Address';

    public static defaultValue = () => {
        return {
        id: 0,
        name: '',
        description: '',
        status: 'active',   
        type: 'address-general',
        typeCaption: 'General',
        street: '',
        region: null,
        regionCaption: '',
        link: '',
        linkIcon: '',
        linkPath: '',
        seq: 0,
        personalinfo: null,
        personalinfoCaption: '',
        app: null,
        appCaption: '',
        product: null,
        productCaption: '',
        }
    }
    
    public static validations = [
        { name: 'name', required: true, minLength: 3 },
        { name: 'description', minLength: 3 },
    ]

    public static columns = [
        { name: 'name', caption: 'Name' },
        { name: 'typeCaption', caption: 'Type' },
        { name: 'status', caption: ' ', type: 'state', default: 'active' },
    ]

    public static columnPicklist = [
        { name: 'name', caption: 'Name' },
        { name: 'typeCaption', caption: 'Type' },
    ]
    
    public static columnPicklistCard = [
        { name: 'linkIcon', type: 'icon' },
        { name: 'name', type: 'caption' },
        { name: 'description' },
    ]

    public static columnPicklistCardType = [
        { name: 'linkIcon', type: 'icon' },
        { name: 'title', type: '' },
    ]

    public static optionStatus = [
        { name: 'active', caption: 'Active' },
        { name: 'inactive', caption: 'Inactive' },
    ]
    
    public static optionType = [
        { name: 'address-general', caption: 'General', icon: 'icons8:location', path: 'https://maps.app.goo.gl/' },
        { name: 'address-home', caption: 'Home', icon: 'icons8:location', path: 'https://maps.app.goo.gl/' },
        { name: 'address-office', caption: 'Office', icon: 'icons8:location', path: 'https://maps.app.goo.gl/' },
        { name: 'link-instagram', caption: 'Instagram', icon: 'icons8:instagram-logo', path: 'https://www.instagram.com/' },
        { name: 'link-facebook', caption: 'Facebook', icon: 'icons8:facebook-logo', path: 'https://www.facebook.com/' },
        { name: 'link-youtube', caption: 'Youtube', icon: 'icons8:youtube-logo', path: 'https://www.youtube.com/' },
        { name: 'link-zoom', caption: 'Zoom', icon: 'icons8:zoom-logo', path: 'https://us04web.zoom.us/' },
        { name: 'link-twitter', caption: 'Twitter', icon: 'icons8:x', path: 'https://www.twitter.com/' },
        { name: 'link-tiktok', caption: 'Tiktok', icon: 'icons8:tiktok-logo', path: 'https://www.tiktok.com/' },
        { name: 'link-tokopedia', caption: 'Tokopedia', icon: '/assets/tokopedia-logo.png', path: 'https://www.tokopedia.com/' },
        { name: 'link-shopee', caption: 'Shopee', icon: '/assets/shopee-logo.png', path: 'https://www.shopee.co.id/' },
        { name: 'link-bukalapak', caption: 'Bukalapak', icon: '/assets/bukalapak-logo.png', path: 'https://www.bukalapak.com/' },
        { name: 'link-lazada', caption: 'Lazada', icon: '/assets/lazada-logo.png', path: 'https://www.lazada.com/' },
        { name: 'link-others', caption: 'Others' },
    ]

    public static optionContact = [
        { name: 'email', caption: 'Email', icon: 'icons8:mail', path: 'mailto:' },
        { name: 'whatsapp', caption: 'Whatsapp', icon: 'icons8:whatsapp-logo', path: 'https://api.whatsapp.com/send?text=&phone=' },
    ]

}